import { ReactElement } from "react";
import { className } from "../../../../../shared/helpers";
import { upArrow } from "../../../../../shared/icons";
import styles from './ProductionNumber.module.scss';

interface ProductionNumberProps
{
    label: string;
    value: number;
    difference: number | null;
    displayIcon: boolean;
}

const ProductionNumber = (props: ProductionNumberProps): ReactElement =>
{
    const getArrowClass = (): string =>
    {
        if (props.displayIcon && props.difference)
        {
            if (props.difference > 0) return styles.isPositive;
            if (props.difference < 0) return styles.isNegative;
        }

        return "";
    }

    return (
        <div className={styles.productionNumber}>
            <div {...className(styles.value, getArrowClass())}>
                <span>{props.value}</span>
                {props.displayIcon && upArrow}
            </div>

            <span className={styles.label}>{props.label}</span>
        </div>
    );
}

export default ProductionNumber;